import React from 'react'

// components
import Image from 'next/image'
import { IMAGE_PATHS_V2 } from '@/shared/consts/imagesPaths'

// styles
import { editButton } from './styles'

interface Props {
  size?: number
  alt?: string
  onClick?: () => void
  theme?: string // In the future we will have dark and light themes but this component will be able to use an specific theme no matter the global theme
}

export const ButtonEdit: React.FC<Props> = ({
  size = 20,
  onClick,
  theme,
  alt = 'edit',
}) => {
  const [themeSelected] = React.useState(theme || 'dark')

  return (
    <div className={editButton}>
      <Image
        src={IMAGE_PATHS_V2.icons.commons + `edit_${themeSelected}.svg`}
        alt={alt}
        width={size}
        height={size}
        onClick={onClick}
        priority={true}
      />
    </div>
  )
}
